"use client";

import { useEffect, useState } from "react";
import { ensureSignedIn, watchUser, type UserDoc } from "@/lib/platform/firebase";

export function usePlan() {
  const [user, setUser] = useState<UserDoc>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;
    ensureSignedIn().then((u) => {
      unsubscribe = watchUser(u.uid, (doc) => {
        setUser(doc);
        setLoading(false);
      });
    });
    return () => unsubscribe?.();
  }, []);

  return { plan: user.plan ?? "free", isPro: user.plan === "pro", loading };
}
